var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel',[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('v-icon',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n            "+_vm._s(_vm.header)+"\n        ")],1)]),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-divider',{staticClass:"mb-4"}),_vm._v(" "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }